var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor assign-owner" },
    [
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("chatbotv2.assignmentMethod"))),
          ]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticClass: "classic-select",
              model: {
                value: _vm.clone.method,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "method", $$v)
                },
                expression: "clone.method",
              },
            },
            [
              _c("a-select-option", { attrs: { value: "algorithmic" } }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.algorithmicAssignment"))),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "static" } }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.staticAssignment"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.clone.method === "static"
        ? _c(
            "section",
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.agentToAssign"))),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticClass: "classic-select",
                  attrs: {
                    placeholder: _vm.$t("chatbotv2.selectAgentPlaceholder"),
                    "allow-clear": "",
                  },
                  model: {
                    value: _vm.clone.staticUserId,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "staticUserId", $$v)
                    },
                    expression: "clone.staticUserId",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "null" } }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.unownedRemoveOwner"))),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.users, function (user) {
                    return _c(
                      "a-select-option",
                      { key: user._id, attrs: { value: user._id } },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(user.name) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("small", [
                _vm._v(_vm._s(_vm.$t("chatbotv2.agentAssignmentHelp"))),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.method === "algorithmic"
        ? _c(
            "section",
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("auto.assignOwnerAlgorithm"))),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticClass: "classic-select",
                  model: {
                    value: _vm.clone.algorithm,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "algorithm", $$v)
                    },
                    expression: "clone.algorithm",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "least_contact" } }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.leastContact"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "random" } }, [
                    _vm._v(_vm._s(_vm.$t("auto.assignOwnerRandom"))),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.method === "algorithmic"
        ? _c(
            "section",
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("auto.assignOwnerDateRange"))),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticClass: "classic-select",
                  model: {
                    value: _vm.clone.dateRange,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "dateRange", $$v)
                    },
                    expression: "clone.dateRange",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "today" } }, [
                    _vm._v(_vm._s(_vm.$t("auto.assignOwnerToday"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "last_7_days" } }, [
                    _vm._v(_vm._s(_vm.$t("auto.assignOwnerLast7Days"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "last_30_days" } }, [
                    _vm._v(_vm._s(_vm.$t("auto.assignOwnerLast30Days"))),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("small", [
                _vm._v(_vm._s(_vm.$t("chatbotv2.agentContactRangeHelp"))),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.method === "algorithmic"
        ? _c(
            "section",
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.distributeOnlyToOnline"))),
              ]),
              _vm._v(" "),
              _c("a-switch", {
                model: {
                  value: _vm.clone.checkOnlineStatus,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "checkOnlineStatus", $$v)
                  },
                  expression: "clone.checkOnlineStatus",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.method === "algorithmic"
        ? _c(
            "section",
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.agentsToExclude"))),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticClass: "classic-select",
                  attrs: { mode: "multiple" },
                  model: {
                    value: _vm.clone.excludeUserIds,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "excludeUserIds", $$v)
                    },
                    expression: "clone.excludeUserIds",
                  },
                },
                _vm._l(_vm.users, function (user) {
                  return _c(
                    "a-select-option",
                    { key: user._id, attrs: { value: user._id } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(user.name) +
                          "\n            "
                      ),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c("small", [
                _vm._v(_vm._s(_vm.$t("chatbotv2.agentsExcludeHelp"))),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.zohoChannelExists
        ? _c(
            "section",
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.zohoCrmSync"))),
              ]),
              _vm._v(" "),
              _c("a-switch", {
                model: {
                  value: _vm.clone.syncOnZoho,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "syncOnZoho", $$v)
                  },
                  expression: "clone.syncOnZoho",
                },
              }),
              _vm._v(" "),
              _c("small", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("chatbotv2.zohoCrmSyncHelp")) +
                    "\n        "
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("a-alert", {
        attrs: {
          type: "info",
          message: _vm.$t("chatbotv2.assignOwnerVisibilityInfo"),
          "show-icon": "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }